import numbro from 'numbro';

/**
 * Round percentage to a specified number of decimal places.
 * Note: Max number is 100.
 *
 * @example
 * roundPercentage(45.45678, 2);    // returns 45.46
 * roundPercentage(23.00, 3);       // returns 23
 * roundPercentage(99.99, 2);       // returns 99
 */
export const roundPercentage = (number: number, decimalPlaces = 2): number => {
  const rounded = Number.parseFloat(number.toFixed(decimalPlaces));

  // handle case with rounding to 100 (first item is 99.99, second is 0.01)
  if (number < 100 && rounded === 100) {
    const factor = 10 ** decimalPlaces;
    return Math.floor(number * factor) / factor;
  }

  // handle case with rounding to 0 (element is 0.00001%)
  if (number > 0 && rounded === 0) {
    return number;
  }

  return rounded;
};

export const isNumber = (value: unknown) => typeof value === 'number' && !Number.isNaN(value);

/**
 *
 * @example
 * isNumericInput(45);    // returns true
 * isNumericInput('23');       // returns true
 * isNumericInput([]);       // returns false
 */
export const isNumericInput = (value: unknown): boolean => {
  if (typeof value !== 'string' && typeof value !== 'number') return false;
  if (Number.isNaN(value)) return false;
  const regex = /^[0-9]+([,.][0-9]+)?$/;
  return regex.test(`${value}`);
};

export const howManyDigitsAfterDecimalPoint = (number: number | string): number => {
  const numberString = `${number}`;
  const separatorIndex = numberString.indexOf('.') !== -1 ? numberString.indexOf('.') : numberString.indexOf(',');

  if (separatorIndex === -1) return 0;

  return numberString.slice(separatorIndex + 1).length;
};

export const getRandomNumber = (digits = 3): number => Math.round(Math.random() * 10 ** digits);

export const prettifyNumber = (value: number): string => {
  const newValue = Number(value);

  if (Math.abs(newValue) >= 1000000000) {
    return numbro(newValue).format('0.0B').toUpperCase();
  }
  if (Math.abs(newValue) >= 1000000) {
    return numbro(newValue).format('0.0M').toUpperCase();
  }
  if (Math.abs(newValue) >= 1000) {
    return numbro(newValue).format('0.0K').toUpperCase();
  }

  return newValue.toString();
};
